import { Group, Text } from "@mantine/core";
import React from "react";
import EditColumnRows from "../actions/EditColumnRows";

const HeaderRenderer = ({
  datafield,
  total,
}) => {
  return (
    <Group wrap="nowrap" gap={4} className="hover-source">
      <Text fw={200} opacity={0.5}>
        {datafield?.name}
      </Text>{" "}
      <EditColumnRows
        current={datafield}
        total={total}
      />
    </Group>
  );
};

export default HeaderRenderer;
